import { defaultLocationCoordinateDisplays } from "@/lib/geo/location-coordinate-display";
import type { UserSettings } from "@/types/user-settings";

/** App defaults when no profile / stored settings exist (server and client). */
export const defaultUserSettings: UserSettings = {
  windUnit: "bft",
  windGustsUnit: "km/h",
  temperatureUnit: "°C",
  precipitationUnit: "mm/hr",
  windWavesUnit: "m",
  snowUnit: "cm",
  altitudeUnit: "m",
  visibilityUnit: "m",
  timeFormat: "24h",
  timezone: "local",
  mapStyle: "sea",
  locationCoordinateDisplays: { ...defaultLocationCoordinateDisplays },
};
